import React, { Component } from 'react';
import './styles.css';

class Loader extends Component {
	render() {
		return (
			<div
				className='loading-container'>
				<div className='loading'></div>
			</div>
		);
	}
}

export default Loader;
